import * as React from 'react';
import Measure from 'react-measure';
import { jsx as _jsx } from "react/jsx-runtime";
export const Resize = /*#__PURE__*/React.memo(({
  onResize,
  resizeNode
}) => {
  const resizeHandling = React.useRef(null);
  const handleResize = React.useCallback(() => {
    if (resizeHandling.current !== null) {
      clearTimeout(resizeHandling.current);
    }

    resizeHandling.current = setTimeout(() => {
      onResize();
    }, 100);
  }, [onResize]);
  return /*#__PURE__*/_jsx(Measure, {
    bounds: true,
    onResize: handleResize,
    children: ({
      measureRef
    }) => /*#__PURE__*/_jsx("div", {
      ref: measureRef,
      style: {
        position: 'relative',
        width: '100%',
        height: '100%'
      },
      children: resizeNode
    })
  });
});
Resize.displayName = 'Resize';